<template>
    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div class="toolbar" id="kt_toolbar">
            <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="true">
                <!-- Réceptionner : DRAFT ou SENT -->
                <button
                    v-if="purchaseCurrent.status === 'DRAFT' || purchaseCurrent.status === 'SENT'"
                    @click.prevent="submitReceive"
                    class="btn btn-sm btn-flex btn-light-warning btn-active-warning fw-bolder me-2"
                    :disabled="isProcessing">
                    <span v-if="!isProcessing">{{ $t("purchase.receive_order") }}</span>
                    <span v-else>{{ $t('loading') }} <span class="spinner-border spinner-border-sm ms-2"></span></span>
                </button>
                <!-- Valider : RECEIVED → ouvre modal choix boutique/magasin -->
                <button
                    v-if="purchaseCurrent.status === 'RECEIVED'"
                    @click.prevent="openValidateModal"
                    class="btn btn-sm btn-flex btn-primary fw-bolder me-2"
                    :disabled="isProcessing">
                    {{ $t("purchase.validate") }}
                </button>
            </app-sub-header>
        </div>

        <div class="container-xxl" v-if="isLoading">
            <Loader />
        </div>

        <div v-else class="post d-flex flex-column-fluid" id="kt_post">
            <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
                <div class="card">
                    <div class="card-body p-12">
                        <div class="d-flex flex-column align-items-start flex-xxl-row">
                            <div class="d-flex flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4">
                                <span class="fs-2x fw-bolder text-gray-800">{{ $t('purchase.supplier_name') }}: {{ purchaseCurrent?.customer?.gender_full_name }}</span>
                            </div>
                            <div class="d-flex flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4">
                                <span class="fs-2x fw-bolder text-gray-800">{{ $t('shop.date') }}: {{ purchaseCurrent.date }}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column align-items-start flex-xxl-row">
                            <div class="d-flex flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4">
                                <span class="fs-2x fw-bolder text-gray-800">{{ $t('shop.number') }} # {{ purchaseCurrent.number }}</span>
                            </div>
                            <div class="d-flex flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4">
                                <div class="row">
                                    <div class="col-auto mt-10">
                                        <span class="fs-2x fw-bolder text-gray-800">{{ $t('purchase.delivery_date') }}:</span>
                                    </div>
                                    <div class="col-6">
                                        <InputDate
                                            name="purchase-delivery-date"
                                            type="text"
                                            labelClass="form-label fs-6 text-black"
                                            :inputClass="'form-control form-control-solid fs-2x fw-bolder text-gray-800'"
                                            :placeholder="$t('purchase.delivery_date')"
                                            :disabled="purchaseCurrent.status !== 'DRAFT' && purchaseCurrent.status !== 'SENT'"
                                            v-model="receptionFormData.delivery_date" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="separator separator-dashed my-10"></div>

                        <!-- Tableau des lignes de commande -->
                        <div class="mb-0">
                            <div class="table-responsive mb-10">
                                <table class="table g-5 gs-0 mb-0 fw-bolder text-gray-700" data-kt-element="items">
                                    <thead>
                                        <tr class="border-bottom fs-7 fw-bolder text-gray-700 text-uppercase">
                                            <th class="min-w-200px w-250px">{{ $t('store.item') }}</th>
                                            <th class="min-w-100px w-100px">{{ $t('shop.lot_unite') }}</th>
                                            <th class="min-w-100px w-100px">{{ $t('store.qty') }}</th>
                                            <th class="min-w-100px w-100px">{{ $t('purchase.conform_or_no_conform') }}</th>
                                            <th class="min-w-100px w-150px text-end">{{ $t('store.conform_quantity') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(content, key) in receptionFormData.order_contents" :key="key">
                                        <tr class="border-bottom border-bottom-dashed">
                                            <td class="ps-0">
                                                <input type="text" readonly class="form-control form-control-solid mb-2"
                                                    :value="content.product_name" />
                                            </td>
                                            <td class="ps-0">
                                                <input readonly class="form-control form-control-solid" type="text"
                                                    :value="content.lot_id ? content.lot?.name : $t('shop.unite')" />
                                            </td>
                                            <td class="ps-0">
                                                <input readonly class="form-control form-control-solid" type="number"
                                                    v-model="content.quantity" />
                                            </td>
                                            <td class="pt-8 text-end text-nowrap">
                                                <div class="d-flex">
                                                    <div class="form-check form-check-custom form-check-solid me-5">
                                                        <input class="form-check-input" type="radio" value="CONFORM"
                                                            v-model="content.state"
                                                            :disabled="!isEditable"
                                                            :id="`conform_yes_${key}`" />
                                                        <label class="form-check-label" :for="`conform_yes_${key}`">{{ $t('store.yes') }}</label>
                                                    </div>
                                                    <div class="form-check form-check-custom form-check-solid">
                                                        <input class="form-check-input" type="radio" value="NO_CONFORM"
                                                            v-model="content.state"
                                                            :disabled="!isEditable"
                                                            :id="`conform_no_${key}`" />
                                                        <label class="form-check-label" :for="`conform_no_${key}`">{{ $t('store.no') }}</label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="pe-7">
                                                <input type="number"
                                                    class="form-control form-control-solid"
                                                    min="0"
                                                    :max="content.quantity"
                                                    :disabled="!isEditable"
                                                    v-model="content.quantity_received"
                                                    placeholder="0" />
                                            </td>
                                        </tr>
                                        <tr v-if="content.state === 'NO_CONFORM'" class="border-bottom border-bottom-dashed">
                                            <td colspan="5" class="ps-2 pb-3 pt-0">
                                                <textarea
                                                    class="form-control form-control-solid"
                                                    rows="2"
                                                    :disabled="!isEditable"
                                                    v-model="content.comment"
                                                    :placeholder="$t('purchase.no_conform_comment_placeholder')" />
                                                <small class="text-danger fw-bold">{{ $t('purchase.no_conform_comment') }}</small>
                                            </td>
                                        </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal de validation (choix boutique/magasin + mise en stock) -->
                <div class="modal fade" tabindex="0" id="validateOrderModal">
                    <div class="modal-dialog">
                        <form @submit.prevent="confirmValidate" class="form">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('purchase.validate') }}</h5>
                                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal">
                                        <span class="svg-icon svg-icon-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <p class="text-muted mb-4">{{ $t('purchase.validate_order_instructions') }}</p>
                                    <!-- Destination -->
                                    <div class="form-group row mb-4">
                                        <div class="col-sm-4 text-gray-800 my-auto fw-bold">{{ $t('store.output.model') }}</div>
                                        <div class="col-sm-8">
                                            <div class="form-check form-check-custom form-check-inline mb-2">
                                                <input class="form-check-input me-2 h-20px w-20px" v-model="validateFormData.type_receiver"
                                                    value="SHOP" required type="radio" id="val-shop" />
                                                <label class="form-check-label me-5 text-gray-800" for="val-shop">{{ $t("store.output.shop") }}</label>
                                                <template v-if="hasModule('pos.warehouse')">
                                                    <input class="form-check-input me-2 h-20px w-20px" v-model="validateFormData.type_receiver"
                                                        value="STORE" required type="radio" id="val-store" />
                                                    <label class="form-check-label text-gray-800" for="val-store">{{ $t("store.output.store") }}</label>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Sélection boutique/magasin -->
                                    <div class="row">
                                        <Select2 v-if="validateFormData.type_receiver === 'SHOP'"
                                            container-class="form-group mt-auto" :multiple="false"
                                            :selectClass="'form-control form-control-solid form-select'"
                                            name="validateShop" :isRequired="true"
                                            :placeholderText="$t('purchase.select_shop')"
                                            :label="$t('purchase.add_shop')" v-model="validateFormData.receiver_id">
                                            <option v-for="shop in shops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
                                        </Select2>
                                        <Select2 v-else
                                            container-class="form-group mt-auto" :multiple="false"
                                            :selectClass="'form-control form-control-solid form-select'"
                                            name="validateStore" :isRequired="true"
                                            :placeholderText="$t('purchase.select_store')"
                                            :label="$t('purchase.add_store')" v-model="validateFormData.receiver_id">
                                            <option v-for="s in stores" :key="s.id" :value="s.id">{{ s.name }}</option>
                                        </Select2>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                                    <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isProcessing">
                                        <span v-if="!isProcessing">{{ $t('purchase.confirm_validate') }}</span>
                                        <span v-else>{{ $t('loading') }} <span class="spinner-border spinner-border-sm ms-2"></span></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import AppSubHeader from "./Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import InputDate from "@/components/InputDate.vue";
import { useRouter, useRoute } from "vue-router";
import Select2 from "@/components/Select2.vue";
import { useHasModule } from '@/composables/hasModule';
const t = (key) => i18n.global.t(key);
const store = useStore();
const { hasModule } = useHasModule();
const route = useRoute();
const router = useRouter();

const title = ref("breadcrumbs.purchase.title");
const breadcrumbs = ref([
    { name: 'breadcrumbs.purchase.list', path: '/admin/suppliers/purchases' },
    { name: 'breadcrumbs.purchase.detail', path: '/admin/suppliers/purchases/view/:id' },
]);

const isLoading = ref(false);
const isProcessing = ref(false);

const purchaseCurrent = computed(() => store.getters['orders/currentOrder']);
const shops = computed(() => store.getters['shop/getShops']);
const stores = computed(() => store.getters["store/getStores"]);

// Formulaire de réception (quantités + conformité)
const receptionFormData = ref({
    delivery_date: null,
    order_contents: [],
});

// Formulaire de validation (destination du stock)
const validateFormData = ref({
    type_receiver: 'SHOP',
    receiver_id: null,
});

// Les lignes sont éditables seulement quand DRAFT ou SENT
const isEditable = computed(() =>
    purchaseCurrent.value?.status === 'DRAFT' || purchaseCurrent.value?.status === 'SENT'
);

function getTaxIds(taxes) {
    return taxes.map(tax => tax.taxe.id);
}

watch(() => purchaseCurrent.value, (order) => {
    if (!order) return;
    receptionFormData.value.delivery_date = order.delivery_date;
    receptionFormData.value.order_contents = order.order_contents.map(content => ({
        id: content.id,
        product_sale_element_id: content.product_sale_element_id,
        quantity: content.quantity,
        quantity_received: ['RECEIVED', 'VALIDATED'].includes(order.status)
            ? content.quantity_received
            : content.quantity,
        product_name: content.product_name,
        lot_id: content.lot_id,
        lot: content.lot,
        state: content.state ?? 'CONFORM',
        comment: content.comments ?? null,
        taxes: getTaxIds(content.order_content_taxes ?? []),
    }));
});

// Réception : soumettre directement les quantités + conformité (pas de modal)
async function submitReceive() {
    isProcessing.value = true;
    try {
        const payload = {
            id: purchaseCurrent.value.id,
            status: 'RECEIVED',
            delivery_date: receptionFormData.value.delivery_date,
            order_contents: receptionFormData.value.order_contents,
        };
        const response = await store.dispatch('orders/updateOrderStatus', payload);
        window.toastr['success'](t('purchase.order_received_success'));
        router.push({ name: 'suppliers-purchases-view', params: { id: response.data.data.id } });
    } catch {
        window.toastr['error'](t('purchase.error_update_status'));
    } finally {
        isProcessing.value = false;
    }
}

// Validation : ouvrir la modal de choix boutique/magasin
function openValidateModal() {
    validateFormData.value.receiver_id = null;
    validateFormData.value.type_receiver = 'SHOP';
    $('#validateOrderModal').modal('show');
}

// Validation : soumettre avec destination → mise en stock
async function confirmValidate() {
    isProcessing.value = true;
    try {
        const payload = {
            id: purchaseCurrent.value.id,
            status: 'VALIDATED',
            type_receiver: validateFormData.value.type_receiver,
            receiver_id: validateFormData.value.receiver_id,
        };
        const response = await store.dispatch('orders/updateOrderStatus', payload);
        $('#validateOrderModal').modal('hide');
        window.toastr['success'](t('purchase.order_validated_success'));
        router.push({ name: 'suppliers-purchases-view', params: { id: response.data.data.id } });
    } catch {
        window.toastr['error'](t('purchase.error_update_status'));
    } finally {
        isProcessing.value = false;
    }
}

async function loadData() {
    await store.dispatch('shop/loadShops', { status: 'all', search: '' });
    // Destination « Magasin » : module Magasins uniquement
    if (hasModule('pos.warehouse')) {
        await store.dispatch('store/loadStore', { status: 'all', search: '' });
    }
    await store.dispatch('orders/getOrderById', route.params.id);
}

onMounted(() => {
    isLoading.value = true;
    loadData()
        .then(() => isLoading.value = false)
        .catch(() => isLoading.value = false);
});
</script>

<style scoped></style>
